var _defs, _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoapRollDispenserGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.26 327.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #39b54a;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #009245;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 108.13,
    cy: 109.25,
    r: 106.43
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 108.15,
    cy: 110,
    r: 34.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.56,89.52h7.3v40.96h-7.17s-.46-41.28-.13-40.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.13,151.17s-1.04,63.91,3.13,74.61,9.37,31.98,9.39,41.41c0,.05,0,.08.01.13.33,1.36,6.05,25.01,9.35,30.67.02.03.03.07.05.1l9.97,27.97c.23.64,1.14.62,1.34-.02l1.3-4.07c.09-.28.34-.47.62-.49l5.97-.44c.34-.03.62-.29.65-.63l.7-6.78c.01-.13.06-.25.14-.35l1.3-1.73c.1-.13.15-.29.14-.45l-.24-6.22c0-.2.07-.39.21-.53l4.28-4.28c.13-.13.2-.29.21-.47l.23-5.22c.01-.3.22-.56.51-.65l3.11-.91c.43-.13.64-.61.43-1.01-1.59-3.02-7.36-14.32-8.72-22.17,0-.02,0-.03,0-.05-.1-.84-2.71-23.11-7.82-45.37l-3.91-18.49s0-.04-.01-.07l-1.53-13.23c-.02-.19-.12-.36-.27-.48-2.33-1.78-21.25-16.81-30.55-40.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoapRollDispenserGreen);
export default __webpack_public_path__ + "static/media/soap_roll_dispenser_green.07935de969b281a6f5c8d2999ac820bd.svg";
export { ForwardRef as ReactComponent };